const VALID_USERNAME = "wowsign.admin";
const VALID_PASSWORD = "wowsign@123";

function createFakeAccessToken() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }

  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export async function loginWithMockService(username, password) {
  await new Promise((resolve) => window.setTimeout(resolve, 350));

  if (username !== VALID_USERNAME || password !== VALID_PASSWORD) {
    throw new Error("Invalid username or password.");
  }

  return {
    accessToken: createFakeAccessToken(),
    user: {
      username: VALID_USERNAME,
      name: "WOWSign Admin",
      role: "Operations Admin",
    },
  };
}
